<app-nav titulo="Garantías rápidas" descripcion="Aquí podrá ver los formularios enviados por los agentes con los datos mínimos para contactar a los involucrados y comenzar una garantía.">
    <div class="fast-warranties">
        <app-data-table
            [rows]="warranties"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
            (updateRows)="updateWarranties($event)"
        ></app-data-table>
    </div>
</app-nav>

<ng-template #buttonsColumnTemplate let-row="row">
    <div class="table-row-buttons">
        <button mat-icon-button class="delete-row-button" matTooltip="Borrar garantía rápida" (click)="deleteRow(row)">
            <mat-icon color="accent">delete</mat-icon>
        </button>
    </div>
</ng-template>
